/**
 * @generated SignedSource<<9616299f14fa67c249ab2a7177b12818>>
 * @relayHash 50a6e629cc1f8b4b18d88d28ec9e7d73
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 79f310721de88992b0fac1a51a3aa4631e0f08790e2a90ef526432cf3b54f967

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "79f310721de88992b0fac1a51a3aa4631e0f08790e2a90ef526432cf3b54f967",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
